// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar___GBS5","avatar--size-tiny":"avatar_avatar--size-tiny__3ntJY"};